<nb-layout>
  @if (dashboardSessionActive() && showShell()) {
    <nb-layout-header>
      <button class="collapse-btn" (click)="toggleSidebar()" nbButton ghost>
        <nb-icon pack="fas" icon="bars"></nb-icon>
      </button>
      <div class="header-spacer"></div>
      <div class="header-right">
        @if (tenantName()) {
          <div class="tenant-chip">
            <nb-icon pack="fas" icon="building"></nb-icon>
            <span>{{ tenantName() }}</span>
          </div>
        }
        <div class="header-divider"></div>
        @if (currentUser(); as currentUser) {
          <div class="user-menu-wrapper">
            <div class="user-section" role="button" tabindex="0"
                 (click)="userMenuOpen = !userMenuOpen" (keydown.enter)="userMenuOpen = !userMenuOpen">
              <img class="user-avatar" [src]="getUserProfile(currentUser)" [alt]="currentUser.firstName">
              <div class="user-info">
                <span class="user-name">{{ currentUser.firstName }} {{ currentUser.lastName }}</span>
              </div>
              <nb-icon class="user-caret" pack="eva"
                       [icon]="userMenuOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
            </div>
            @if (userMenuOpen) {
              <div class="user-menu-dropdown">
                <div class="user-menu-item" role="button" tabindex="0"
                     (click)="openChangePasswordDialog(); userMenuOpen = false"
                     (keydown.enter)="openChangePasswordDialog(); userMenuOpen = false">
                  <nb-icon pack="eva" icon="lock-outline"></nb-icon>
                  Passwort ändern
                </div>
                <div class="user-menu-item user-menu-item--danger" role="button" tabindex="0" routerLink="/logout"
                     (click)="userMenuOpen = false" (keydown.enter)="userMenuOpen = false">
                  <nb-icon pack="eva" icon="log-out-outline"></nb-icon>
                  Ausloggen
                </div>
              </div>
            }
          </div>
        }
        <wr-notifications-dropdown></wr-notifications-dropdown>
      </div>
    </nb-layout-header>
  }
  @if (dashboardSessionActive() && showShell()) {
    <nb-sidebar [(state)]="sidebarState" [nbSpinner]="loading()">
      @if (menuItems(); as items) {
        <div class="scrollable-content">
          <a class="corporate-logo" [ngClass]="sidebarState()" routerLink="/landing" title="Startseite"
             data-cy="corporate-logo-home">
            <img src="assets/pictures/gema-m.svg" alt="GEMA">
            @if (sidebarState() !== 'compacted') {
              <span>MyGemaPro</span>
            }
          </a>
          <wr-menu [items]="items"></wr-menu>
        </div>
      }
    </nb-sidebar>
  }
  <nb-layout-column>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </nb-layout-column>
</nb-layout>
